<template >
    <div class="pages memberGroup">
        <div class="f1 mb-30">
            <div class="d1">
                围绕会员行为与属性创建标签，深度洞悉客户画像
            </div>
            <div class="d2">
                <div class="text">
                    <p> 查看积木云助手的使用教程说明，快速了解配<span>查看详情 >></span></p>
                </div>
                <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
            </div>
        </div>
        <div class="content1">
            <div class="f3">
                <div class="ipt">
                    <p>
                        <el-input
                        class="iptRdio"
                        placeholder="请输入标签名称搜索"
                        suffix-icon="el-icon-search"
                        v-model="query.keyword_search"
                        ></el-input>
                        <el-select class="iptRdio" v-model="value" placeholder="请选择业务渠道">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </p>
                    <p class="btns">
                        <el-button class="btn-12" @click="addGroup" type="primary" round><img src="../../assets/images/newIcon/grouplabel_icon2.png" alt=""> 标签组</el-button>
                        <el-button class="btn-12" @click="addLabel" type="primary" round><img src="../../assets/images/newIcon/addlabel_icon.png" alt=""> 新增标签</el-button>
                        <span class="b" @click="openFullScreen1" v-loading.fullscreen.lock="fullscreenLoading">
                            <i></i> 标签同步 
                            <el-tooltip class="item" effect="dark" content="Right Center 提示文字" placement="right">
                                <img src="../../assets/images/newIcon/synchronous_icon2.png" alt="">
                            </el-tooltip>
                        </span>
                    </p>
                </div>
                <el-table
                :data="tableData3"
                :header-cell-style="{background:'#EEEEEE',textAlign:'center',fontSize:'12px'}"
                style="width: 100%;"
                 :cell-style="{textAlign:'center',fontSize:'12px'}"
                >
                <el-table-column
                prop="name"
                label="标签名称"
                >
                </el-table-column>
                <el-table-column
                prop="number"
               
                label="标签组"
                >
                </el-table-column>
                <el-table-column
                prop="xmember"
                label="业务系统"
                cell-style="background:red;"
                >
                </el-table-column>
                <el-table-column
                prop="lmember"
                label="应用人数"
               >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="微信人数"
                >
                </el-table-column>
                <el-table-column
                prop="names"
                 show-overflow-tooltip
                label="标签条件"
                >
                </el-table-column>
                <el-table-column
                prop="names2"
                label="标签来源"
                >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="操作"
                width="160"
                >
                    <template slot-scope="scope">
                        <el-button type="text" @click="edit">编辑</el-button>
                        <el-button type="text" @click="del">删除</el-button>
                    </template>
                </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="page">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            style="margin-top: 24px;"
            :current-page="query.page_index"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="query.page_size"
            layout="prev, pager, next, sizes, jumper"
            :total="total"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
const QUERY={
    keyword_search:"",
    page_index: 1,
    page_size: 10,
}
export default {
    data() {
        return {
            fullscreenLoading:false,
            query:JSON.parse(JSON.stringify(QUERY)),
            tabPosition:1,
            value:"",
            options: [{
            value: '选项1',
            label: '全部'
            }, {
            value: '选项2',
            label: '小橘帮帮'
            }, {
            value: '选项3',
            label: '颐安中台'
            }, {
            value: '选项4',
            label: '业务系统3'
            }],
            tableData3: [{
                name: '活跃人群',
                number:"标签组1",
                xmember:"颐安中台",
                lmember:"100",
                labellv:"100",
                names:"运营类标签无具体规则",
                names2:"运营标签",
                },{
                name: '新客户人群',
                number:"标签组1",
                xmember:"颐安中台",
                lmember:"100",
                labellv:"100",
                names:"「VIP等级 包含 黄金会员、白金会员「VIP等级 包含 黄金会员、白金会员」…「VIP等级 包含 黄金会员、白金会员」…",
                names2:"运营标签",
                },{
                name: '潜在客户人群',
                number:"标签组1",
                xmember:"颐安中台",
                lmember:"100",
                labellv:"100",
                names:"月消费次数超过2次的月消费次数超过2次的月消费次数超过2次的月消费次数超过2次的",
                names2:"运营标签",
                },{
                name: '忠实客户人群',
                number:"标签组1",
                xmember:"颐安中台",
                lmember:"100",
                labellv:"100",
                names:"运营类标签无具体规则",
                names2:"运营标签",
                },{
                name: '高消费人群',
                number:"标签组1",
                xmember:"颐安中台",
                lmember:"100",
                labellv:"100",
                names:"运营类标签无具体规则",
                names2:"运营标签",
                },{
                name: '活跃人群',
                number:"标签组1",
                xmember:"颐安中台",
                lmember:"100",
                labellv:"100",
                names:"运营类标签无具体规则",
                names2:"运营标签",
            },],
            total:90,
            type:1
        }
    },
    methods: {
        openFullScreen1() {
            this.fullscreenLoading = true;
            setTimeout(() => {
            this.fullscreenLoading = false;
            }, 2000);
        },
        edit(){
            this.$router.push({name:"newLabel",query:{id:111}})
        },
        del(){
             this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        addGroup(){
             this.$router.push({name:"labelGroup"})
        },
        addLabel(){
            this.$router.push({name:"newLabel"})
        },
        goAnal(){
             this.$router.push({name:"populationAnalysis",query:{id:22222}})
        },
        goDetail(){
            this.$router.push({name:"groupDetail",query:{id:22222}})
        },
        addImport(){
            this.$router.push({name:"newMemberGroup",query:{id:"1111"}})
        },
        chageType(t){
            this.type=t;
        },
        handleSizeChange(val) {
            this.query.page_size = val;
            // this.getTableData();
        },
        handleCurrentChange(val) {
            this.query.page_index = val;
            // this.getTableData();
        },
    },
}
</script>
<style>
    .el-popover{
        min-width: 80px !important;
    }
    .el-tooltip__popper.is-dark{
        width:200px;
    }
</style>
<style lang="less" scoped>
  
    .memberGroup{
        /deep/ .el-radio-button:first-child .el-radio-button__inner{
            border-radius: 18px 0 0 18px;
        }
        /deep/ .el-radio-button:last-child .el-radio-button__inner{
            border-radius: 0 18px 18px 0;
        }
        
        .content1{
            .f2{
                display: flex;
                justify-content: space-between;
                .li{
                    width:18%;
                    box-sizing: border-box;
                    background: #fff;
                    border-radius: 10px;
                    div{
                        &:first-child{
                            background: url('../../assets/images/newIcon/group_recommend_bc.png') no-repeat;
                            padding:30px 15px;
                            margin:0 15px;
                            margin-top:15px;
                            background-size:100% 100%;
                            color:#fff;
                            p{
                                &:first-child{
                                    margin-bottom:10px;
                                    font-size: 16px;
                                    font-weight: 500;
                                    color: #FFFFFF;
                                }
                                &:last-child{
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #FFFFFF;
                                }
                            }
                        }
                        &:nth-child(2){
                            display: flex;
                            margin:20px 0;
                            p{
                                width:50%;
                                text-align: center;
                                span{
                                    display: block;
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #666666;
                                    &:first-child{
                                        margin-bottom:10px;
                                        font-size: 20px;
                                        font-weight: bold;
                                        color: #327EFF;
                                    }
                                }
                            }
                        }
                        &:nth-child(3){
                            display: flex;
                            border-top:1px solid #EDEDED;
                            p{
                                &:first-child{
                                    border-right:1px solid #ededed;
                                }
                                padding:15px;
                                width:50%;
                                text-align: center;
                                img{
                                    margin-right:10px;
                                    width:16px;
                                    height:16px;
                                    vertical-align: middle;
                                }
                                span{
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #3285F8;
                                }
                            }
                        }
                    }
                }
            }
            .f3{
                background: #ffff;
                .ipt{
                    padding:15px;
                    display: flex;
                    justify-content: space-between;
                    /deep/.el-input .el-input__inner{
                        border-radius: 30px;
                        background: #F6F6F6;
                        border: 0px;
                    }
                    /deep/ .el-select>.el-input{
                        width:160px;
                    }
                    .iptRdio{
                        margin-right: 15px;
                    }
                    p{
                        display: flex;
                        img{
                            width:16px;
                            vertical-align: middle;
                        }
                    }
                    .btns{
                        font-size: 12px;
                        font-weight: 400;
                        color: #0091FF;
                        i{
                            margin-right:10px;
                            display: inline-block;
                            width: 8px;
                            height: 8px;
                            background: #0091FF;
                            border-radius: 50%;
                            border: 1px solid #E0E0E0;
                        }
                        
                        .b{
                           margin-left:15px;
                           display: flex;
                           align-items: center;
                           img{
                                margin-left:10px;
                            }
                        }
                        
                    }
                }
                
                /deep/ .el-button{
                    margin-right:10px;
                }
            }
        }
        .content2{
            .f2{
                display: flex;
                justify-content: space-between;
                .li{
                    width:31%;
                    display: flex;
                    padding:30px 30px;
                    box-sizing: border-box;
                    img{
                        width:56px;
                        height:56px;
                        margin-left: 90px;
                        margin-right:15px;
                    }
                    p{
                        &:first-child{
                            margin-bottom:10px;
                            font-size: 16px;
                            font-weight: 400;
                            color: #2E2E2E;
                        }
                        &:last-child{
                            font-size: 28px;
                            font-weight: bold;
                            color: #2E2E2E;
                        }
                    }
                    &:first-child{
                        background:url('../../assets/images/newIcon/category_cousume_bc.png') no-repeat;
                        background-size:100% 100%;
                    }
                    &:nth-child(2){
                        background:url('../../assets/images/newIcon/category_business_bc.png') no-repeat;
                        background-size:100% 100%;
                    }
                    &:nth-child(3){
                        background:url('../../assets/images/newIcon/category_access_bc.png') no-repeat;
                        background-size:100% 100%;
                    }
                }
                .active{
                    background:url('../../assets/images/newIcon/category_cousumeblue_bc.png') no-repeat !important;
                    background-size:100% 100% !important;
                    p{
                         color: #fff !important;
                    }
                }
                .active2{
                    background:url('../../assets/images/newIcon/category_businessblue_bc.png') no-repeat !important;
                     background-size:100% 100% !important;
                }
                .active3{
                    background:url('../../assets/images/newIcon/category_accessblue_bc.png') no-repeat !important;
                     background-size:100% 100% !important;
                }
            }
        }
    }
    .title{
        display: flex;
        justify-content: space-between;
        p{
            font-size: 16px;
            font-weight: 500;
            color: #333940;
            img{
                margin-right:10px;
                width:20px;
                height:20px;
                vertical-align: middle;
                &:last-child{
                    margin-left:10px;
                    width:78px;
                    height:20px;
                }
            }
            &:last-child{
                span{
                    color: #0091FF;
                }
            }
            
        }
    }
    .f1{
            display: flex;
            justify-content: space-between;
            .d1{
                height:106px;
                box-sizing: border-box;
                padding-right: 6%;
                padding-left: 4%;
                padding-top: 30px;
                width:65%;
                 background:url('../../assets/images/newIcon/jijmu_title_bg.png') no-repeat;
                 background-size:100% 100%;
                font-size: 21px;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 24px;
                letter-spacing: 7px;
            }
            .d2{
                width:34%;
                display: flex;
                align-items: center;
                height:106px;
                .text{
                    display: flex;
                    align-items: center;

                    padding:4px 30px;
                    // background: #fff;
                    height:100%;
                    font-size: 14px;
                    font-weight: 500;
                    color: #333333;
                    img{
                        width:305px;
                    }
                    span{
                        font-size: 14px;
                        font-weight: 500;
                        color: #327EFF;
                    }
                    background: url('../../assets/images/newIcon/popupwindow_background.png') no-repeat;
                    background-size:100% 100%;
                }
 
                img{
                    width:58px;
                    height:58px;
                }
               
            }
    }
    .page{
        /deep/ .el-pagination .btn-prev{
            margin-right:10px;
        }
        /deep/ .el-pagination .btn-next{
            margin-left:10px;
        }
    }
    .ged{
        p{
            text-align: center;
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            &:first-child{
                color:#327EFF;
                padding-bottom:8px;
                border-bottom:1px solid #EFEFEF;
            }
            &:last-child{
                padding-top:8px;
            }
        }
    }
</style>